import { mapActions } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { formMixin } from '@/components/forms/mixin';

export default {
  mixins: [
    formMixin,
  ],
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      dontShowAgain: false,
      swiperOptions: {
        direction: 'horizontal',
        pagination: '.attach-to-home__pagination',
        paginationClickable: true,
      },
      items: [
        {
          textTop: 'Follow these quick steps to a place a PredictIt icon on your iPhone.',
          image: 'step1',
          textBottom: 'First, hit the share button in the footer at the bottom of the screen (available in Safari only).',
        },
        {
          textTop: 'Scroll left and tap the icon in the image below.',
          image: 'step2',
          textBottom: '',
        },
        {
          textTop: "Choose a simple title, hit 'Add' and you are set to go!",
          image: 'step3',
          textBottom: '',
        },
      ],
    };
  },
  methods: {
    ...mapActions('app', ['dontShowAttachToHomeNotification']),
  },
  beforeDestroy() {
    if (this.dontShowAgain) this.dontShowAttachToHomeNotification();
  },
};



// WEBPACK FOOTER //
// ./src/components/attach-to-home/attach-to-home.js